"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _Text = _interopRequireDefault(require("../../Text"));

require("../styles/_stage.scss");

function getPrimaryClass(a) {
  var b = a.selected,
      c = a.disabled;
  return c ? "stage--disabled" : b ? "stage--selected" : "stage--future";
}

function Stage(a) {
  var b = a.text,
      c = a.selected,
      d = a.onClick,
      e = a.disabled,
      f = getPrimaryClass({
    selected: c,
    disabled: e
  });
  return _react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])("stage", f, {
      "stage--clickable": d
    }),
    onClick: !e && d,
    onKeyDown: !e && (0, _onEnterPressed["default"])({
      onClick: d
    })
  }, _react["default"].createElement("div", {
    className: "stage__arrow"
  }, _react["default"].createElement("div", {
    className: "stage__arrow__left"
  }), _react["default"].createElement("div", {
    className: "stage__arrow__ctr"
  }, _react["default"].createElement(_Text["default"], {
    body: !0,
    className: "stage__arrow__ctr__text"
  }, b)), _react["default"].createElement("div", {
    className: "stage__arrow__right"
  })));
}

var _default = (0, _react.memo)(Stage);

exports["default"] = _default;